import { Typography } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import { RenderCellExpand } from "../../shared/components";
import { formatCurrency } from "../../shared/utils";
import useStyles from "./tablaVehiculosStyles";

const PLAN_DESCRIPTION = {
  "01": "Amplia",
  "02": "Limitada",
  "03": "Básica",
  "07": "Topdriver",
};

const getPlanDescription = (plan) => PLAN_DESCRIPTION[plan] || "No disponible";

const TablaVehiculos = ({ vehiclePremiums }) => {
  const classes = useStyles();
  const vehiculos = Array.isArray(vehiclePremiums) ? vehiclePremiums : [];

  const columns = [
    {
      field: "model",
      headerName: "Modelo",
      width: 90,
      headerClassName: "header",
      renderCell: ({ value }) => value ?? "-",
    },
    {
      field: "description",
      headerName: "Descripción",
      flex: 1,
      minWidth: 140,
      headerClassName: "header",
      renderCell: RenderCellExpand,
    },
    {
      field: "serialNumber",
      headerName: "Serie",
      width: 130,
      headerClassName: "header",
      renderCell: RenderCellExpand,
    },
    {
      field: "plan",
      headerName: "Cobertura",
      width: 100,
      headerClassName: "header",
      renderCell: ({ value }) => getPlanDescription(value),
    },
    {
      field: "paymentPeriod",
      headerName: "Forma de pago",
      width: 135,
      headerClassName: "header",
      renderCell: ({ value }) => value || "No disponible",
    },
    {
      field: "netPremiumFleetSubsequent",
      headerName: "Prima neta",
      width: 110,
      headerClassName: "header",
      headerAlign: "right",
      align: "right",
      renderCell: ({ value }) => formatCurrency(value),
    },
    {
      field: "totalPremiumFleetSubsequent",
      headerName: "Prima total",
      width: 110,
      headerClassName: "header",
      headerAlign: "right",
      align: "right",
      renderCell: ({ value }) => formatCurrency(value),
    },
  ];

  const rows = vehiculos.map((vehiculo, index) => ({
    ...vehiculo,
    id: index,
  }));

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Vehículos cotizados</Typography>
      {rows.length > 0 ? (
        <div className={classes.tablaWrapper}>
          <DataGrid
            columns={columns}
            rows={rows}
            className={classes.grid}
            autoHeight
            hideFooter={rows.length <= 100}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row.id}
          />
        </div>
      ) : (
        <Typography className={classes.vacio}>
          No se encontró información
        </Typography>
      )}
    </div>
  );
};

export default TablaVehiculos;
